import { social } from "./social";

export const formuArea = {
  label: "Forum Area",
  path: (tenantName) => `${social.path(tenantName)}/forumArea`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Social Connect",
      path: `${social.path(tenantName)}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: formuArea.label,
      path: `${formuArea.path(tenantName)}`,
      onClick: () => navigate(`${formuArea.path(tenantName)}`),
    },
  ],
};
